import React from "react";
import ReactDOM from "react-dom";

import "assets/scss/material-kit-react.scss?v=1.9.0";

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
